import { useRoute, useRouter } from 'vue-router'

import Network from '@/Network'
import { useErrorToast } from '@/composables/useErrorToast'
import type { DSAttendanceStatus } from '@/constants/ds-attendance.constants'

import { routeNameForStatus } from '../utils/status-route-map'

/**
 * "Enviar registro" do card novo: a mesma tela do "Ver detalhes" da aba velha (a de
 * aguardando envio do container), com os filtros da aba na query para a volta cair no
 * mesmo recorte. Mesma navegação do `handleDetails` do `Index.vue`.
 */
export function useOpenAttendanceContainer() {
  const route = useRoute()
  const router = useRouter()
  const { notifyError } = useErrorToast()

  /**
   * `status` omitido = usa o status REAL do registro buscado. É o caso do link para o
   * registro substituto (rejected-sheet-resubmission): ele pode já ter saído de "aguardando
   * envio", e mandar para a rota errada mostraria a tela de envio de um registro em auditoria.
   */
  async function openContainer(containerId: number, status?: string): Promise<void> {
    if (status && !routeNameForStatus(status as DSAttendanceStatus)) return
    try {
      const details = await Network.dsAttendance.getById(containerId)
      const resolvedStatus = status ?? details.status
      const routeName = routeNameForStatus(resolvedStatus as DSAttendanceStatus)
      if (!routeName) return
      await router.push({
        name: routeName,
        params: { attendanceId: String(containerId) },
        query: { ...route.query },
        state: { details: JSON.parse(JSON.stringify(details)), status: resolvedStatus }
      })
    } catch (error) {
      notifyError(error, 'Não foi possível abrir a solicitação.')
    }
  }

  return { openContainer }
}
